/* globals google */
'use strict';
var urlParams = new URLSearchParams(window.location.search);
var infowindow = new google.maps.InfoWindow();

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}
var map;
/**
 * Uses google maps api to render a map
 */
function maps() {
    // Init U.S. Map in the center of the viewport
    var latlng = new google.maps.LatLng(parseFloat($("#lat").val()), parseFloat($("#long").val()));
    var mapOptions = {
        scrollwheel: false,
        zoom: 5,
        center: latlng
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    var mapdiv = $('.map-canvas').attr('data-locations');

    mapdiv = JSON.parse(mapdiv);

    var bounds = new google.maps.LatLngBounds();

    // Customized google map marker icon with svg format
    var markerImg = {
        path: 'M17.9159 19.4362L17.3359 18.6215L17.3263 18.6285L17.9159 19.4362ZM6.08405 19.4362L6.67369 18.6285L6.66404 18.6216L6.08405 19.4362ZM11.2252 26.4453L12.2098 26.2706L11.2252 26.4453ZM12.7748 26.4453L13.7595 26.6199V26.6199L12.7748 26.4453ZM18.4959 20.2508C21.218 18.3128 23 15.1759 23 11.625H21C21 14.4857 19.5672 17.033 17.336 18.6216L18.4959 20.2508ZM23 11.625C23 5.69277 18.045 0.9375 12 0.9375V2.9375C17.0007 2.9375 21 6.85672 21 11.625H23ZM12 0.9375C5.95503 0.9375 1 5.69277 1 11.625H3C3 6.85672 6.99927 2.9375 12 2.9375V0.9375ZM1 11.625C1 15.1759 2.78202 18.3128 5.50406 20.2508L6.66404 18.6216C4.4328 17.033 3 14.4857 3 11.625H1ZM12.2098 26.2706C11.5182 22.3715 8.56064 20.006 6.67365 18.6285L5.49446 20.2439C7.36413 21.6087 9.69888 23.566 10.2405 26.6199L12.2098 26.2706ZM12 26.1221C12.068 26.1221 12.1236 26.1495 12.1568 26.1789C12.1875 26.2062 12.2041 26.2387 12.2098 26.2706L10.2405 26.6199C10.384 27.4289 11.0791 28.1221 12 28.1221V26.1221ZM11.7902 26.2706C11.7959 26.2387 11.8125 26.2062 11.8432 26.1789C11.8764 26.1495 11.932 26.1221 12 26.1221V28.1221C12.9209 28.1221 13.616 27.4289 13.7595 26.6199L11.7902 26.2706ZM17.3263 18.6285C15.4394 20.006 12.4818 22.3715 11.7902 26.2706L13.7595 26.6199C14.3011 23.566 16.6359 21.6087 18.5055 20.2439L17.3263 18.6285Z',
        fillColor: 'black',
        fillOpacity: 2,
        scale: 0.8,
        strokeColor: 'black',
        strokeWeight: 2,
        anchor: new google.maps.Point(13, 30),
        labelOrigin: new google.maps.Point(12, 12),
    };

    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var icon = window.location.origin ;
        icon +=$('#icon-hidden').val();
        var lable = parseInt(key, 10) + 1;
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            icon: icon
        });

        function scrollToStore(element, parent) {
            
            $(parent).animate({
              scrollTop: $(parent).scrollTop() + $(element).offset().top - $(parent).offset().top
            }, {
              duration: 'slow',
              easing: 'swing'
            });
          }

        marker.addListener('click', function (event) {
            event.preventDefault;
            infowindow.close();

            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.open(map, marker);
            $('.results .card-body').removeClass('active');
            $('.results .card-body#'+(item.id).toLowerCase()).addClass('active');

            var store_select_desktop = $('.store-locator-container .results-card .results');
            var store_block = store_select_desktop.find('.card-body.active');
            

            var store_details_mobile = $('.store-details-mobile');
            store_details_mobile.find('.store-details-content').empty().append($('.results .card-body.active').html());
            store_details_mobile.addClass('show');

            if ( $(window).width() < 840 ) {
                $('html, body').animate({
                    scrollTop: $('.map-canvas').offset().top
                }, 1000);
            }

            scrollToStore(store_block, store_select_desktop);

            centerMapStore(item.latitude,item.longitude);
        });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
    });
    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }
}

$('.store-details-mobile .icon-close-small').on('click', function () {
    $('.store-details-mobile').removeClass('show');
});
/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show();
    } else {
        $('.store-locator-no-results').hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);
    if ($mapDiv.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');
    var radius = $('.results').data('radius');
    var url = $form.attr('action');
    var urlParams = { radius: radius };

    var payload = $form.is("form")
        ? $form.serialize()
        : {
            postalCode: $form.find('[name="postalCode"]').val(),
            lat: $form.find('[name="lat"]').val(),
            long: $form.find('[name="long"]').val()
        };

    url = appendToUrl(url, urlParams);
    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
        }
    });
    return false;
}

function centerMapStore(latitude,longitude) {
    const pos = {
      lat: latitude,
      lng: longitude,
    };
    map.setCenter(pos);
}

let autocomplete;
let address1Field;
let address2Field;
let postalField;
let latField;
let lngField;

function initAutocomplete() {
    postalField = document.querySelector("#store-postal-code");
    latField = document.querySelector("#lat");
    lngField = document.querySelector("#long");
    var center = new google.maps.LatLng(parseFloat($("#lat").val()), parseFloat($("#long").val()));
    var defaultBounds = new google.maps.LatLngBounds();
    // Create the autocomplete object, restricting the search predictions to
    // addresses in the US and Canada.
    autocomplete = new google.maps.places.Autocomplete(postalField, {
        bounds: defaultBounds,
        componentRestrictions: { country: [$("#storeCountry").val()] },
        fields: ["address_components", "geometry", "name"],
        types: [],
        strictBounds: false,
    });
    //    address1Field.focus();
    // When the user selects an address from the drop-down, populate the
    // address fields in the form.
    autocomplete.addListener("place_changed", fillInAddress);
};

function fillInAddress() {
    // Get the place details from the autocomplete object.
    const place = autocomplete.getPlace();
    let postcode = "";
    var lat = 0.0;
    var lng = 0.0;
    if (place.geometry && place.geometry.location) {
        lat = place.geometry.location.lat();
        lng = place.geometry.location.lng();
    }

    var address = place.address_components;
    for (var i = 0; i < address.length; i++) {
        const componentType = address[i].types[0];
        switch (componentType) {
            case "street_number": {
                postcode += ' ' + address[i]["long_name"];
                break;
            }
            case "route": {
                postcode += ' ' + address[i]["long_name"];
                break;
            }
            case "postal_code": {
                postcode += ' ' + address[i]["long_name"];
                break;
            }
            case "postal_code_suffix": {
                break;
            }
            case "locality":{
                postcode += ' ' + address[i]["long_name"];
                break;
            }
            case "administrative_area_level_1": {
                break;
            }
            case "administrative_area_level_2": {
                break;
            }
            case "country":{
              break;
            }
        }

    }
    postalField.value = postcode;
    latField.value = lat;
    lngField.value = lng;
};

function triggerChangeCountry(){
    $("#storeCountry").on('change', function(){
        initAutocomplete();
        clearCityField();
        
        var lat = parseFloat($("#storeCountry :selected").data('lat'));
        var lng = parseFloat($("#storeCountry :selected").data('lng'));
        if (lat && lng) {
            centerMapStore(lat, lng);
            
            $('#lat').val(lat);
            $('#long').val(lng);

            $('.btn-storelocator-search[type="button"]').trigger('click');
        }
    });
}

function fillCountryCityFields(lng, lat){
    const geocoder = new google.maps.Geocoder();
    $('#lat').val(parseFloat(lat));
    $('#long').val(parseFloat(lng));
    const latlng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      };
    geocoder.geocode({ location: latlng }).then((response) => {
        if (response.results[0]) {
            response.results[0].address_components.forEach(component => {
                if (component.types.includes('country')) {
                    $("#storeCountry").val(component.short_name);
                } else if (component.types.includes('locality')) {
                    $("#store-postal-code").val(component.short_name);
                }
            });
            $('.invalid-feedback').empty();
        }
    })
    .catch((e) => window.alert("Geocoder failed due to: " + e));

}

function clearCityField(){
    $('#store-postal-code').val('');
}

function getStores(url) {
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            $.spinner().stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
        }
    });
}

module.exports = {
    init: function () {
        if ($('.map-canvas').data('has-google-api')) {
            maps();
            initAutocomplete();
            triggerChangeCountry();
            $('.skp-search-icon').click(function () {
                $('.store-locator-container form.store-locator').submit();
                });
            $(document).on('click', '.results  .card-body', function (e) {

            infowindow.close();

            $('.results .card-body').removeClass('active');
            var $this = $(this);
            $this.toggleClass('active');
            var lat = $this.data('lat');
            var long = $this.data('long');
            centerMapStore(lat,long);

            var title = $this.data('store-info');
                var storeLocation = new google.maps.LatLng(lat, long);
                var icon = window.location.origin ;
                var marker = new google.maps.Marker({
                    position: storeLocation,
                    map: map,
                    title:  title,
                    icon: icon
                });
                infowindow.setOptions({
                    content: $this.data('store-details')
                });
                infowindow.open(map, marker);
            
        });
        } else {
            $('.store-locator-no-apiKey').show();
        }

        // if (!$('.results').data('has-results')) {
        //     $('.store-locator-no-results').show();
        // }
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }
            var $detectLocationButton = $('.detect-location');
            var url = $detectLocationButton.data('action');
            var radius = $('.results').data('radius');
            navigator.geolocation.getCurrentPosition(position => {
                var urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };

                url = appendToUrl(url, urlParams);
                getStores(url);
                fillCountryCityFields(urlParams.long, urlParams.lat);
            }, () => {
                var urlParams = {
                    radius: radius,
                    storeCountry: $("#storeCountry :selected").val(),
                    lat: parseFloat($("#storeCountry :selected").data('lat')),
                    long: parseFloat($("#storeCountry :selected").data('lng'))
                };
                
                url = appendToUrl(url, urlParams);
                getStores(url);
            });
            
            $.spinner().stop();
        });
    },

    search: function () {
        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
            search($(this));

        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
            search($(this));
        });
    },

    changeRadius: function () {
        $('.store-locator-container .radius').change(function () {
            var radius = $(this).val();
            var searchKeys = $('.results').data('search-key');
            var url = $(this).data('action-url');
            var urlParams = {};

            if (searchKeys.postalCode) {
                urlParams = {
                    radius: radius,
                    postalCode: searchKeys.postalCode
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius: radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long
                };
            }

            url = appendToUrl(url, urlParams);
            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            getStores(url)
        });
    },
    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', (function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .results');
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e
            };

            $('body').trigger('store:selected', data);
        }));
    },
    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', (function () {
            $('.select-store').prop('disabled', false);
        }));
    }
};

var btnStore = $('.btn-store'),
    panelShow =$('.panel-show');
    $(document).on('click', '.btn-store', function (e) {
  var self__ =$(this);
  self__.toggleClass('active');
});
function deplace(){
    var wdithofwindow = $(window).width();
    if(wdithofwindow <= 756){
        $('.SKP-Store .skp-store-result').insertAfter('.SKP-Store .col-lg-8');
    }
}
deplace();
$(window).on('resize', function(){
    deplace()
});
$(window).on('load', function() {
    if(!urlParams.has('storeid')) {
        $('.detect-location').trigger('click');
    }
    centerMapStore(parseFloat($("#lat").val()),parseFloat($("#long").val()));
});

function showMapListe(){
    $('.showListe').on('click', function () {
        $(this).addClass('active').siblings().removeClass('active');
         $('.map-canvas').addClass('d-none').removeClass('d-block');
         $('.skp-store-result').addClass('d-block').removeClass('d-none');

    });
    $('.showMap').on('click', function () {
        $(this).addClass('active').siblings().removeClass('active');
        $('.skp-store-result').addClass('d-none').removeClass('d-block');
        $('.map-canvas').addClass('d-block').removeClass('d-none');
   });
}
showMapListe()

$('.btn-storelocator-search').on('click', function () {
    if (($('.skp-city-store').val().length == 0)) {
        $('.skp-city-store').parent().next($('.invalid-feedback')).removeClass('d-none');
    } else {
        $('.skp-city-store').parent().next($('.invalid-feedback')).addClass('d-none');
    }
});


$('.SKP-Location input[type=text]').on('keyup', function () {
    var input = $(this);
    if (($(input).val().length !== 0)) {
        $(input).parent().next($('.invalid-feedback')).addClass('d-none');
    }
});